import React, { useState, useEffect } from 'react';

const API_ENDPOINT = '/api';

export default function AdminLeadsView() {
  const [leads, setLeads] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = filter === 'has-website' ? '?hasWebsite=true' : filter === 'no-website' ? '?hasWebsite=false' : '';
    fetch(`${API_ENDPOINT}/admin/leads${params}`, { credentials: 'include' })
      .then(r => r.json())
      .then(data => { setLeads(data.leads || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [filter]);

  const handleExport = () => {
    window.open(`${API_ENDPOINT}/admin/leads/export`, '_blank');
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-text-primary dark:text-text-primary-dark">Leads</h1>
        <button onClick={handleExport} className="bg-action text-white px-4 py-2 rounded-full text-sm font-semibold hover:bg-action-hover transition-colors">
          Export CSV
        </button>
      </div>

      <div className="flex gap-2 mb-4">
        {[['all', 'All'], ['has-website', 'Has Website'], ['no-website', 'No Website']].map(([val, label]) => (
          <button key={val} onClick={() => setFilter(val)}
            className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${filter === val ? 'bg-action text-white' : 'bg-surface dark:bg-surface-dark text-text-muted dark:text-text-muted-dark'}`}>
            {label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-text-muted dark:text-text-muted-dark text-center py-12">Loading leads...</div>
      ) : leads.length === 0 ? (
        <div className="text-text-muted dark:text-text-muted-dark text-center py-12">No leads yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border dark:border-border-dark text-text-muted dark:text-text-muted-dark text-left">
                <th className="pb-3 pr-4 font-medium">Name</th>
                <th className="pb-3 pr-4 font-medium">Company</th>
                <th className="pb-3 pr-4 font-medium">Email</th>
                <th className="pb-3 pr-4 font-medium">Website</th>
                <th className="pb-3 pr-4 font-medium">Colors</th>
                <th className="pb-3 pr-4 font-medium">Consent</th>
                <th className="pb-3 pr-4 font-medium">Date</th>
                <th className="pb-3 font-medium">Card</th>
              </tr>
            </thead>
            <tbody>
              {leads.map(lead => (
                <tr key={lead.id} className="border-b border-border-subtle dark:border-border-subtle-dark">
                  <td className="py-3 pr-4 text-text-primary dark:text-text-primary-dark font-medium">{lead.first_name} {lead.last_name}</td>
                  <td className="py-3 pr-4 text-text-secondary dark:text-text-secondary-dark">{lead.company || '—'}</td>
                  <td className="py-3 pr-4 text-text-secondary dark:text-text-secondary-dark">
                    <a href={`mailto:${lead.email}`} className="hover:text-action transition-colors">{lead.email}</a>
                  </td>
                  <td className="py-3 pr-4 text-text-secondary dark:text-text-secondary-dark">
                    {lead.website_url
                      ? <a href={lead.website_url} target="_blank" rel="noopener noreferrer" className="hover:text-action transition-colors truncate block max-w-[150px]">{lead.website_url}</a>
                      : <span className="text-text-muted dark:text-text-muted-dark">—</span>}
                  </td>
                  <td className="py-3 pr-4">
                    {lead.scraped_primary_color ? (
                      <div className="flex gap-1">
                        <div style={{ width: '1rem', height: '1rem', borderRadius: '50%', backgroundColor: lead.scraped_primary_color, border: '1px solid rgba(255,255,255,0.1)' }} title={lead.scraped_primary_color} />
                        {lead.scraped_secondary_color && <div style={{ width: '1rem', height: '1rem', borderRadius: '50%', backgroundColor: lead.scraped_secondary_color, border: '1px solid rgba(255,255,255,0.1)' }} title={lead.scraped_secondary_color} />}
                      </div>
                    ) : <span className="text-text-muted dark:text-text-muted-dark">—</span>}
                  </td>
                  <td className="py-3 pr-4">
                    {lead.consent ? <span className="text-success dark:text-success-dark text-xs font-medium">Yes</span> : <span className="text-error dark:text-error-dark text-xs font-medium">No</span>}
                  </td>
                  <td className="py-3 pr-4 text-text-muted dark:text-text-muted-dark text-xs">{new Date(lead.created_at).toLocaleDateString()}</td>
                  <td className="py-3">
                    <a href={`/${lead.card_slug}`} target="_blank" rel="noopener noreferrer" className="text-action hover:underline text-xs">View →</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
